import React from 'react'
import {
    useHistory
} from "react-router-dom";

import { firebaseServices } from '../../../Firebase/FirebaseServices'

import { useSelector, useDispatch } from 'react-redux';
import { pageUp, setPage, currentPage, scoreReset, EP2_scoreReset, dbSavedTimeStamp } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './ES.css'



function EpisodeSelector() {
    const history = useHistory();
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    let dbTimeFolder = useSelector(dbSavedTimeStamp);
    return (
        <div className='ES_imageAnimate'>
            <div className='ES_entryBox'>
                <div className='ES_episode1Div'>
                    <button className='ES_button' onClick={() => { dispatch(setPage(3)); dispatch(scoreReset()); firebaseServices.database().ref(`/userDetails/${dbTimeFolder}/episode1`).child('episode1_Clicked').set('true') }}>
                        {language === 'english' ?
                            <div><span className='ES_buttonTextEnglish'>Episode 1</span><div>{`.`}</div></div>
                            :
                            <div><span className='ES_buttonTextUrdu'>قسط اول</span><div>{`.`}</div></div>
                        }
                    </button>
                </div>


                <div className='ES_episode2Div'>
                    <button className='ES_button' onClick={() => { dispatch(setPage(27)); dispatch(EP2_scoreReset()); firebaseServices.database().ref(`/userDetails/${dbTimeFolder}/episode2`).child('episode2_Clicked').set('true') }}>
                        {language === 'english' ?
                           <div> <span className='ES_buttonTextEnglish'>Episode 2 </span></div>
                            :
                            <div><span className='ES_buttonTextUrdu'>قسط دوئم</span></div>
                        }
                    </button>
                </div>

                <div className='ES_episode3Div'>
                    <button className='ES_button' onClick={() => { dispatch(setPage(55)); dispatch(EP2_scoreReset()); firebaseServices.database().ref(`/userDetails/${dbTimeFolder}/episode3`).child('episode3_Clicked').set('true') }}>
                        {language === 'english' ?
                           <div> <span className='ES_buttonTextEnglish'>Episode 3 </span></div>
                            :
                            <div><span className='ES_buttonTextUrdu'>قسط سوئم</span></div>
                        }
                    </button>
                </div>

            </div>
        </div>
    )
}

export default EpisodeSelector;